<div class="issues-line-graph" [style.height.px]="graphHeight"
     [ngStyle]="!isResponsive ? {'margin-left': '-10px'} : null">
  <canvas #graph width="{{graphWidth}}" height="{{graphHeight}}"></canvas>
</div>
